import * as React from 'react';
import { Survey, UserReportType, SurveyReportType } from '../../../models';
import { NotificationService, SurveyDataService, SurveyReportTypeDataService } from '../../../services';

interface SurveyReportTypeUserFormProps {
    notificationService: NotificationService;
    userId: number;
    orgId?: number;
}

interface SurveyReportTypeUserFormState {
    surveys: Survey[];
    selectedSurveyId: number;
    selectedSurveyReportTypeId: number;
    userReportTypes: UserReportType[];
}

export class SurveyReportTypeUserForm extends React.Component<SurveyReportTypeUserFormProps, SurveyReportTypeUserFormState> {
    
    private surveyReportTypeDataService = new SurveyReportTypeDataService(this.props.notificationService);
    private surveyService = new SurveyDataService(this.props.notificationService);

    constructor(props: SurveyReportTypeUserFormProps) {
        super(props);

        this.state = {
            surveys: [],
            selectedSurveyId: -1,
            selectedSurveyReportTypeId: -1,
            userReportTypes: []
        };
    }

    componentDidMount() {

        this.surveyService.getAllForSecondaryReports(this.props.orgId).then((surveys: Survey[]) => {
            this.setState({
                surveys: surveys
            });
        });

        this.surveyReportTypeDataService.getAllForUser(this.props.userId).then((urts: UserReportType[]) => {
            this.setState({
                userReportTypes: urts
            });
        });
    }

    render() {
        return (
            <div>
                <div>
                    <div className="row">
                        <div className="col-xs-4">
                            <label>Survey</label>
                            <select className="form-control" value={this.state.selectedSurveyId} onChange={(e: any) => this.setState({selectedSurveyId: parseInt(e.target.value, 10)})} >
                                <option value={-1}>- Select -</option>
                                {this.state.surveys.map((s: Survey) => {
                                    return <option key={`survey-${s.id}`} value={s.id}>{s.name}</option>;
                                })}
                            </select>
                        </div>
                        <div className="col-xs-4">
                            <label>Survey Report Type</label>
                            {(() => {
                                var s = this.survey();
                                
                                if (!s) {
                                    return <select className="form-control" />;
                                }
                                
                                return <select className="form-control" value={this.state.selectedSurveyReportTypeId} onChange={(e: any) => this.setState({selectedSurveyReportTypeId: parseInt(e.target.value, 10)})} >
                                    <option value={-1}>- Select -</option>
                                    {s.surveyReportTypes.map((sr: SurveyReportType) => {
                                        return <option key={`survey-report-${sr.id}`} value={sr.id}>{sr.name}</option>;
                                    })}
                                </select>;
                            })()}
                        </div>
                        <div className="col-xs-4">
                            <label>Action</label>
                            <br />
                            <a className="btn btn-default btn-block" onClick={(e: any) => this.addSurveyReportType(this.surveyReportType())}>Set Override</a>
                        </div>
                    </div>
                </div>
                <div>
                    <label>Survey Report Type Overrides</label>
                    {this.state.userReportTypes.map((sruo: UserReportType, sruoInd: number) => {
                        return <div className="row" key={`sruo-${sruoInd}`}>
                            <div className="col-xs-4">
                                <span>{sruo.surveyReportType && sruo.surveyReportType.survey && sruo.surveyReportType.survey.name}</span>
                            </div>
                            <div className="col-xs-4">
                                <span>{sruo.surveyReportType && sruo.surveyReportType.name}</span>
                            </div>
                            <div className="col-xs-4">
                                <a className="btn btn-danger" onClick={(e: any) => this.removeUserSurveyReportType(sruo.id)}>Remove</a>
                            </div>
                        </div>;
                    })}
                </div>
            </div>);
    }

    private survey() {
        if (this.state.selectedSurveyId === - 1) {
            return undefined;
        }

        return this.state.surveys.find((s2: Survey) => {
            return s2.id === this.state.selectedSurveyId;
        });
    }

    private surveyReportType() {
        if (this.state.selectedSurveyId === - 1 || this.state.selectedSurveyReportTypeId === - 1) {
            return undefined;
        }

        var s = this.state.surveys.find((s2: Survey) => {
            return s2.id === this.state.selectedSurveyId;
        });

        if (!s) {
            return undefined;
        }

        return s.surveyReportTypes.find((srt: SurveyReportType) => {
            return srt.id === this.state.selectedSurveyReportTypeId;
        });
    }

    private addSurveyReportType(sr: SurveyReportType | undefined) {
        if (!sr) {
            return;
        }
        var userSurveyReportTypes = this.state.userReportTypes;
        
        var o: UserReportType = {
            id: 0,
            userID: this.props.userId,
            surveyReportTypeID: this.state.selectedSurveyReportTypeId
        };
        this.surveyReportTypeDataService.createUserSurveyReportType(o).then((r: any) => {
            userSurveyReportTypes.push(r.created);
            if (r.removed) {
                var ind = userSurveyReportTypes.findIndex(x => x.id === r.removed);
                if (ind > -1) {
                    userSurveyReportTypes.splice(ind, 1);
                }
            }
            this.setState({
                userReportTypes: userSurveyReportTypes
            });
        });
    }

    private removeUserSurveyReportType(id: number) {
        this.surveyReportTypeDataService.deleteUserSurveyReportType(id).then(() => {
            this.setState({
                userReportTypes: this.state.userReportTypes.filter((sruo: UserReportType) => {
                    return sruo.id !== id;
                })
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/SurveyReportTypeUserForm.tsx